export const isFree = (price) => {
  return price === '0'
}

export const noPrice = (price) => {
  return price.length === 0
}
